import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "team-content" }
const _hoisted_2 = { class: "email" }

import { UserItem } from '@/services/entities/UserItem';
import { DxButton } from 'devextreme-vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TeamMember',
  props: {
    member: { Type: {} as UserItem, default: {} as UserItem },
    isTeamLead: { type: Boolean, default: false },
},
  emits: ["remove"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

function removeMember() {
    emit("remove", props.member);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(props.isTeamLead ? 'lead' : 'member')
    }, _toDisplayString(props.member.fullName), 3),
    _createElementVNode("div", _hoisted_2, _toDisplayString(props.member.email != props.member.fullName ? props.member.email : ""), 1),
    _createElementVNode("div", null, [
      _createVNode(_unref(DxButton), {
        hint: "Remove from team",
        icon: "trash",
        "styling-mode": "contained",
        type: "normal",
        onClick: removeMember
      })
    ])
  ]))
}
}

})